import React, { lazy } from 'react';
const testimonials = [{
  name: 'Giulia Marchetti',
  city: 'Milano',
  role: 'Maestra 3ª elementare',
  rating: 5,
  text: 'Ho recuperato i miei weekend! In 5 minuti preparo lezioni di arte che prima mi richiedevano ore. I bambini sono entusiasti e i genitori mi fanno i complimenti.',
  avatar: 'https://i.pravatar.cc/150?img=47'
}, {
  name: 'Francesca Russo',
  city: 'Napoli',
  role: 'Insegnante 1ª elementare',
  rating: 5,
  text: 'Dopo 12 anni di insegnamento, finalmente ho trovato un kit che davvero funziona. Le attività sono progressive e i bambini imparano divertendosi.',
  avatar: 'https://i.pravatar.cc/150?img=44'
}, {
  name: 'Maria Bianchi',
  city: 'Roma',
  role: 'Docente 5ª elementare',
  rating: 5,
  text: "Il Registro dell'Esperto mi ha cambiato la vita. Le valutazioni sono allineate alle linee guida MIUR e finalmente posso giustificare ogni voto in maniera oggettiva.",
  avatar: 'https://i.pravatar.cc/150?img=49'
}, {
  name: 'Elena Conti',
  city: 'Torino',
  role: 'Maestra 2ª elementare',
  rating: 5,
  text: "I laboratori sono pronti all'uso, basta stampare e portare in classe. Una vera salvezza nelle settimane più impegnative dell'anno scolastico.",
  avatar: 'https://i.pravatar.cc/150?img=20'
}, {
  name: 'Sara Ferrari',
  city: 'Bologna',
  role: 'Insegnante 4ª elementare',
  rating: 5,
  text: "Vale ogni centesimo. Il manuale Magic Color ha trasformato i disegni dei miei alunni in piccole opere d'arte. La direttrice mi ha chiesto come ho fatto!",
  avatar: 'https://i.pravatar.cc/150?img=45'
}, {
  name: 'Chiara Esposito',
  city: 'Palermo',
  role: 'Docente di sostegno',
  rating: 5,
  text: 'Anche i miei alunni con BES partecipano con entusiasmo. Le attività sono inclusive e adattabili. Lo consiglio a tutte le colleghe.',
  avatar: 'https://i.pravatar.cc/150?img=48'
}, {
  name: 'Valentina Greco',
  city: 'Firenze',
  role: 'Maestra 3ª elementare',
  rating: 5,
  text: 'Il materiale LIM è eccezionale. I bambini si emozionano davanti a ogni lezione. Ho già consigliato il Kit a tutte le mie colleghe del plesso.',
  avatar: 'https://i.pravatar.cc/150?img=32'
}, {
  name: 'Laura Romano',
  city: 'Verona',
  role: 'Insegnante 1ª elementare',
  rating: 5,
  text: "Il Kit Accoglienza mi ha salvato il primo giorno di scuola. Tutto pronto, organizzato e bellissimo. Le mamme erano impressionate dall'aula decorata.",
  avatar: 'https://i.pravatar.cc/150?img=16'
}, {
  name: 'Roberta Costa',
  city: 'Bari',
  role: 'Docente 5ª elementare',
  rating: 5,
  text: 'Finalmente un percorso completo dalla 1ª alla 5ª. Coerente, progressivo e con obiettivi chiari. Un investimento che si ripaga in poche settimane.',
  avatar: 'https://i.pravatar.cc/150?img=23'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 sm:px-6 relative overflow-hidden" data-id="element-396">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(249,115,22,0.08) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-397"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-398">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16" data-id="element-399">
          <span className="inline-flex items-center gap-2 bg-secondary/10 border border-secondary/20 text-secondary font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-4" data-id="element-400">
            ⭐ +500 RECENSIONI VERIFICATE
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-401">
            Cosa dicono le insegnanti{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-402">
              di tutta Italia
            </span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto font-medium" data-id="element-403">
            Da Milano a Palermo, oltre 1.500 docenti hanno già trasformato il
            loro modo di insegnare arte e immagine.
          </p>

          {/* Aggregate rating */}
          <div className="flex items-center justify-center gap-3 mt-6" data-id="element-404">
            <span className="text-secondary text-xl sm:text-2xl" data-id="element-405">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-main font-bold text-lg sm:text-xl" data-id="element-406">
              4.9/5
            </span>
            <span className="text-text-sec text-sm sm:text-base" data-id="element-407">
              (+500 recensioni)
            </span>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-408">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 flex flex-col hover:border-primary/40 hover:shadow-[0_0_30px_rgba(59,130,246,0.08)] transition-all duration-300" data-id="element-409">
              {/* Stars */}
              <div className="flex items-center gap-2 mb-3" data-id="element-410">
                <span className="text-secondary text-base" data-id="element-411">
                  {'⭐'.repeat(t.rating)}
                </span>
                <span className="text-cta-green text-[10px] font-bold uppercase tracking-wider bg-cta-green/10 px-2 py-0.5 rounded-full border border-cta-green/20" data-id="element-412">
                  ✓ Verificato
                </span>
              </div>

              {/* Quote */}
              <p className="text-text-main text-sm sm:text-base leading-relaxed mb-5 flex-1" data-id="element-413">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-414">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover flex-shrink-0 border-2 border-primary/20" loading="lazy" width={44} height={44} data-id="element-415" />
                <div className="min-w-0 flex-1" data-id="element-416">
                  <p className="font-bold text-text-main text-sm leading-tight" data-id="element-417">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs leading-tight mt-0.5" data-id="element-418">
                    {t.role} •{' '}
                    <span className="text-orange-400 font-semibold" data-id="element-419">
                      📍 {t.city}
                    </span>
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        {/* CTA */}
        <div className="text-center mt-10 sm:mt-14" data-id="element-420">
          <a href="#pricing" className="btn-primary-pulse inline-block bg-cta-green text-bg-dark font-black text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_0_40px_rgba(34,224,138,0.4)] border border-white/20 ring-2 ring-cta-green/30" data-id="element-421">
            🚀 UNISCITI A +1.500 INSEGNANTI
          </a>
        </div>
      </div>
    </section>;
}